import { ChangeDetectorRef, Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Automationaction } from '@src/app/models/automationaction';
import { ACTION_FIELD_SCHEMAS, ActionFieldConfig } from './fields-config';
import { AutomationactionService } from './service/automationaction.service';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';
import { firstValueFrom } from 'rxjs';
import { Automation } from '@src/app/models/automation';


@Component({
  selector: 'app-automationaction',
  templateUrl: './automationaction.component.html',
  styleUrls: ['./automationaction.component.css'],
})
export class AutomationactionComponent {
  @Input() automationAction: Automationaction;
  @Input() automation: Automation;
  @Input() isOpen: boolean;
  @Output() setAutomationCollapse = new EventEmitter<string>();
  autocollapse: boolean;
  form: FormGroup;
  fieldConfig: ActionFieldConfig[] = [];

  customers: { label: string; value: string }[] = [];
  templates: { label: string; value: string }[] = [];

  constructor(
    private fb: FormBuilder,
    private automationActionService: AutomationactionService,
    private datastore: DatastoreService,
    private cdr: ChangeDetectorRef
  ) { }

  // async ngOnInit() {
  //   this.loadCustomers();
  //   await this.loadTemplates();
  //   this.buildForm(); // subscription is handled *inside* here now
  // }

  async ngOnChanges(): Promise<void> {
    if (this.automationAction) {
      this.loadCustomers();
      await this.loadTemplates();
      this.buildForm();
    }
  }

  getFieldOptionValues(field: ActionFieldConfig): { label: string; value: string }[] {
    if (!field.options) return [];
    return field.options.map(opt =>
      typeof opt === 'string' ? { label: opt, value: opt } : opt
    );
  }

  collapsetoggle() {
    if (!this.automationAction?.actionId) {
      return;
    }
    this.setAutomationCollapse.emit(this.automationAction.actionId);
  }


  trackByFieldKey(index: number, field: { key: string }) {
    return field.key;
  }
  buildForm(): void {
    const actionType = this.automationAction.type;
    const baseFields = ACTION_FIELD_SCHEMAS[actionType] || [];

    this.fieldConfig = baseFields.map(field => {
      if (field.dynamicSource === 'customers') {
        return { ...field, options: this.customers };
      }
      if (field.dynamicSource === 'templates') {
        return { ...field, options: this.templates };
      }
      return field;
    });

    this.form = this.fb.group({});

    for (const field of this.fieldConfig) {
      const savedValue = this.automationAction[field.key]; // ✅ look directly on the root object

      this.form.addControl(
        field.key,
        this.fb.group({
          value: [
            savedValue?.value ?? field.defaultValue ?? '',
            field.required ? Validators.required : [],
          ],
          fieldType: [
            savedValue?.fieldType ??
            (field.defaultValue?.includes?.('{{') ? 'Template' : 'Value'),
          ],
        })
      );
    }

    // Static fields
    this.form.addControl(
      'sortOrder',
      new FormControl(this.automationAction.sortOrder ?? 0)
    );
    this.form.addControl(
      'name',
      new FormControl(this.automationAction.name ?? '', Validators.required)
    );
    this.form.addControl(
      'description',
      new FormControl(this.automationAction.description ?? '')
    );
    this.form.addControl(
      'type',
      new FormControl(this.automationAction.type ?? '', Validators.required)
    );
  }




  loadCustomers() {
    const raw = this.datastore.customers.getValue();
    this.customers = raw.map(c => ({ label: c.title, value: c.customerId }));
  }

  async loadTemplates() {
    const rawTemplates = await firstValueFrom(this.automationActionService.getProjectTemplates(this.automationAction.organizationId));

    this.templates = rawTemplates.map(t => ({ label: t.title, value: t.templateId }));
    //console.log('Loaded templates:', this.templates);
  }

  saveAction() {
    const updatedAction = {
      ...this.automationAction,
      ...this.form.value,
    };
    this.automationActionService.updateAction(
      updatedAction.organizationId,
      updatedAction.automationId,
      updatedAction.actionId,
      updatedAction
    ).subscribe();
  }

  deleteAction() {
    this.automationActionService.deleteAction(
      this.automationAction.organizationId,
      this.automationAction.automationId,
      this.automationAction.actionId
    ).subscribe();
  }
}
